import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Instagram OAuth Callback Component
 * 
 * This component handles the callback from Instagram OAuth.
 * It extracts the authorization code or error from the URL parameters
 * and sends it back to the parent window via postMessage.
 * The parent window (InstagramOAuthButton) will then handle the code exchange
 * and complete the authentication flow.
 */
export default function InstagramOAuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    const error = searchParams.get("error");

    if (error) {
      // Send error message to parent window
      window.opener?.postMessage(
        {
          type: "INSTAGRAM_OAUTH_ERROR",
          error: error,
        },
        window.location.origin
      );
      window.close();
      return;
    }

    if (code) {
      // Send code to parent window for processing
      window.opener?.postMessage(
        {
          type: "INSTAGRAM_OAUTH_CODE",
          code: code,
        },
        window.location.origin
      );
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">
          Processing Instagram authentication...
        </p>
      </div>
    </div>
  );
}
